import { Colors, Router, Utils } from '@lightningjs/sdk';
import lng from '@lightningjs/core';

export default class AddProfile extends lng.Component {
  static _template() {
    return {
      Circle: {},
      Icon: { collision: true },
      Text: {},
      FocusRing: {},
    };
  }

  _construct() {
    super._construct();
    this.spacing = 0;
  }

  set src(val) {
    this._src = val;
  }

  get src() {
    return this._src;
  }

  set title(val) {
    this._title = val;
  }

  get title() {
    return this._title;
  }

  set data(val) {
    this._data = val;
  }

  set index(val) {
    this._index = val;
  }

  get data() {
    return this._data;
  }

  get _Icon() {
    return this.tag('Icon');
  }

  get _FocusRing() {
    return this.tag('FocusRing');
  }

  get _Text() {
    return this.tag('Text');
  }

  get _Cirlce() {
    return this.tag('Circle');
  }

  _focus() {
    this._FocusRing.smooth = { color: Colors('#02AC25').get() };
    this._Icon.smooth = { color: Colors('#02AC25').get() };
    this._Text.smooth = { color: Colors('#02AC25').get() };
  }

  _unfocus() {
    this._FocusRing.smooth = { color: Colors('#d6d6d7').get() };
    this._Icon.smooth = { color: Colors('#ffffff').get() };
    this._Text.smooth = { color: Colors('#ffffff').get() };
  }

  _handleEnter() {
    Router.navigate('profile/create-profile');
  }

  _handleHover() {
    this.fireAncestors('$setState', 'Profiles');
    this.fireAncestors('$setIndex', this._index);
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }

  _firstEnable() {
    this._FocusRing.patch({
      w: this.w + this.spacing,
      h: this.h + this.spacing,
      mount: 0.5,
      x: this.w / 2,
      y: this.h / 2,
      zIndex: 2,

      texture: lng.Tools.getRoundRect(
        this.w + this.spacing,
        this.h + this.spacing,
        this.w / 2,
        5,
        Colors('#d6d6d7').get(),
        false
      ),
    });
    this._Icon.patch({
      w: 60,
      h: 60,
      x: 100,
      y: 70,
      texture: lng.Tools.getSvgTexture(Utils.asset(this._src), 60, 60),
      color: Colors('#ffffff').get(),
    });
    this._Text.patch({
      x: 127,
      y: 140,
      mountX: 0.5,
      text: {
        text: this._title,
        fontSize: 30,
        textColor: Colors('#ffffff').get(),
        textAlign: 'center',
      },
    });
    this._Cirlce.patch({
      rect: true,
      clipping: true,
      color: Colors('#807F84').get(),
      w: 254,
      h: 254,
      texture: {
        type: lng.textures.ImageTexture,
        src: Utils.asset('images/greyImage.png'),
        resizeMode: { type: 'cover', w: 254, h: 254 },
      },
      shader: {
        type: lng.shaders.RoundedRectangle,
        radius: 127,
      },
    });
  }
}
